import { render } from "./KpiSummaryRow.vue?vue&type=template&id=bfb20c3c&scoped=true"
import script from "./KpiSummaryRow.vue?vue&type=script&lang=js"
export * from "./KpiSummaryRow.vue?vue&type=script&lang=js"

import "./KpiSummaryRow.vue?vue&type=style&index=0&id=bfb20c3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfb20c3c"]])

export default __exports__